<template>
    <a v-bind="{href:url}">授权</a>
</template>

<script>
    export default {
        name: "Invite",
        data(){
            return{
                appId: "wx6c763386bdfc2d86",
                redirectUrl: "http://127.0.0.1:8080/wxAuth",
                url: ""
            }
        },
        created() {
            let userId =  this.$route.query.userId;
            if(userId){
                this.url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+this.appId+"&redirect_uri="+this.redirectUrl+"&response_type=code&scope=snsapi_userinfo&state="+userId+"#wechat_redirec"
            }else{
                this.url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+this.appId+"&redirect_uri="+this.redirectUrl+"&response_type=code&scope=snsapi_base#wechat_redirec"
            }
            this.redirectUrl= encodeURIComponent(this.redirectUrl);
        },
        mounted(){

        },
        methods:{

        }
    }
</script>

<style scoped>

</style>